/**
 * Uppercases the first letter in a string.
 */
const firstToUpper = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);

export default firstToUpper;
